import { render, staticRenderFns } from "./CommunityContentCard.vue?vue&type=template&id=3c6b2863&scoped=true&"
import script from "./CommunityContentCard.vue?vue&type=script&lang=js&"
export * from "./CommunityContentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityContentCard.vue?vue&type=style&index=0&id=3c6b2863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b2863",
  null
  
)

export default component.exports